import script from "./IsArayanlarScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./IsArayanlarScreen.vue?vue&type=script&setup=true&lang=js"

import "./IsArayanlarScreen.vue?vue&type=style&index=0&id=4b5baebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5baebc"]])

export default __exports__